import { ComponentProps } from 'react';
import dynamic from 'next/dynamic';

import { Accordion as SpAccordion } from './index.js';
import { AccordionItem as SpAccordionItem } from './index.js';

export const Accordion = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpAccordion,
        ComponentProps<typeof SpAccordion>
    >
>(() => import('./index.js').then(({ Accordion }) => Accordion), {
    ssr: false,
});
export const AccordionItem = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpAccordionItem,
        ComponentProps<typeof SpAccordionItem>
    >
>(() => import('./index.js').then(({ AccordionItem }) => AccordionItem), {
    ssr: false,
});
